<template>
  <div v-if="klines" class="kchart-box">
    <e-chart :options="options" :group="group" />
  </div>
</template>

<script>
  import {
    mapState,
    mapGetters
  } from 'vuex';
  export default {
    name: 'k-kdj',
    props: ['klines', 'group'],
    computed: {
      ...mapState('kchart', ['colors']),
      ...mapGetters('kchart', ['makeKdj']),
      options() {
        const {
          klines,
          colors
        } = this
        return this.makeKdj({
          klines,
          colors
        })
      }
    }
  }
</script>
